import { GlobalConstantsTableCols } from "globales-projekt-angular";

export class ConstantsTableColsUebersichtGebaeude extends GlobalConstantsTableCols {
  

  public static getColumns(isAdd: boolean): string[] {
    const actionColumn = isAdd ? GlobalConstantsTableCols.ADD : GlobalConstantsTableCols.REMOVE;
    return [GlobalConstantsTableCols.VORSCHAU_BILD, GlobalConstantsTableCols.WERT, actionColumn];
  }
}